<div style="text-align: center;">
  <p-chart #chart type="bar" [data]="basicData" [options]="horizontalOptions" [style.height.px]="height" (click)="refresh()" (onEvent)="onEvent($event)"></p-chart>
</div>
